import React from 'react';
import './Header.css';

export default function Header() {
    return (
        <header className="site-header">
            <div className="header-left">
                <img
                    src="/logo_abes_tagline_horizontal_verde-amarelo.png"
                    alt="Logo ABES"
                    className="abes-logo"
                />
            </div>
            <div className="header-right">
                <a
                    href="https://abes.com.br"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="abes-link"
                >
                    Acesse o site da ABES
                </a>
            </div>
        </header>
    );
}
